import React, { Component } from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { Draggable } from 'react-beautiful-dnd'

import { hiddenInPaging } from '../../../functions'

import RangeForm from '../forms/range-form'
import SelectForm from '../forms/select-form'

import { LinkIcon } from '../../../icons'

class TableGroup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDropdown: false,
      showSelectForm: false,
      focusMemberSelector: false,
      preventFaderUpdates: false
    }
  }

  renderDropdown(item) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showSelectForm: true, showDropdown: false})}>Change monitor</li>
              {
                item.member || item.value
                ? <li onClick={() => this.setState({showDropdown: false}, () => this.props.editRiderItem({id: item.id, member: null, value: null}))}>Remove {(item.member && item.member.name) || item.value} from this monitor</li>
                : <li onClick={() => this.setState({showSelectForm: true, focusMemberSelector: true, showDropdown: false})}>Assign a member</li>
              }
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.deleteRiderItem(item.id))}>Remove this monitor</li>
            </ul>
          : null
        }
      </div>
    )
  }

  itemIsSelected(selectedItem) {
    const { item } = this.props

    if (item.id) {
      if (selectedItem.type && selectedItem.type.includes('stereo')) {
        this.props.editRiderItem({...selectedItem, id: item.id})
      } else {
        this.setState({preventFaderUpdates: true}, () => this.props.editRiderItem({...selectedItem, id: item.id, class: 'monitor'}))
      }
    }
  }

  render() {
    const { view, value, item, itemIndex, itemTypes, members, paging } = this.props
    const { showSelectForm, focusMemberSelector, preventFaderUpdates } = this.state

    const { children } = item
    const childItems = [] // TODO: Remove class: 'fader' items from children on stereo-pair (monitor-group) creation for correct indexes

    children.forEach((child, index) => {
      if (child.class.includes('monitor')) childItems.push(child)
    })

    if (hiddenInPaging(paging, itemIndex) && hiddenInPaging(paging, itemIndex+1)) return null

    const size = hiddenInPaging(paging, itemIndex) || hiddenInPaging(paging, itemIndex+1) ? 1 : 2
    const isStereo = size === 2

    const className = classnames({
      'table-group': true,
      'table-group--stereo': true,
      'table-group--stereo-split': !isStereo
    })

    const isIncrementing = hiddenInPaging(paging, itemIndex) === false && hiddenInPaging(paging, itemIndex+1) === true

    const channelsClassName = classnames({
      'table-group-channels': true,
      'table-group-channels--next': isIncrementing === true,
      'table-group-channels--previous': isIncrementing === false
    })

    const channelClassName = classnames({
      'table-group-channel': true,
      'table-group-channel--left': isIncrementing === true,
      'table-group-channel--right': isIncrementing === false
    })

    return (
      <Draggable draggableId={item.id} isDragDisabled={true} type="item">
        {(provided, snapshot) => (
          <div className={className} style={{minWidth: `${100/paging.size*size}%`, maxWidth: `${100/paging.size*size}%`}}>
            <div className="table-group--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle}
              {...provided.dragHandleProps} >
              <div className="table-group-handle" />

              <div className="table-group-head">
                {
                  view.editable
                  ? this.renderDropdown(item)
                  : null
                }

                <div className={channelsClassName}>
                  <LinkIcon className="table-group-channels-link-icon" />

                  {
                    isStereo
                    ? childItems.map((childItem, index) => {
                        const channelClassName = classnames({
                          'table-group-channel': true,
                          'table-group-channel--left': index === 0,
                          'table-group-channel--right': index === 1
                        })

                        return <div key={index} className={channelClassName}>{childItem.channel}</div>
                      })
                    : <div className={channelClassName}>
                        {
                          isIncrementing
                          ? item.channel.split('-')[0]
                          : item.channel.split('-')[1]
                        }
                      </div>
                  }
                </div>

                {
                  showSelectForm && view.editable
                  ? <SelectForm
                      item={item}
                      value={value}
                      itemTypes={[...itemTypes, {class: 'monitor', type: null, title: 'Assign member'}]}
                      members={members}
                      focusMemberSelector={focusMemberSelector}
                      onItemSelect={(selectedItem) => this.setState({showSelectForm: false, focusMemberSelector: false}, () => this.itemIsSelected(selectedItem))}
                      removeFocus={() => this.setState({showSelectForm: false, focusMemberSelector: false})} />
                  : <div className="name" onClick={() => this.setState({showSelectForm: true})}>{value}</div>
                }
              </div>

              <div className="table-item">
                {
                  childItems.map((childItem, index) => {
                    if (childItem.class.includes('monitor')) {
                      const { faders } = childItem

                      if (hiddenInPaging(paging, itemIndex+index)) return null // TODO: if {class: 'fader'} children are present, wrong index will be supplied to hiddenInPaging; could be replaced with position

                      return (
                        <div key={childItem.id || index} className="table-item-body table-item-body--output">
                          {
                            faders && faders.length > 0
                            ? faders.map((fader, index) => {
                                return (
                                  <RangeForm key={index}
                                    view={view}
                                    child={fader}
                                    value={parseInt(fader.value, 10)}
                                    createRiderItem={(item) => preventFaderUpdates !== true ? this.props.createRiderItem(item) : null}
                                    editRiderItem={(item) => preventFaderUpdates !== true ? this.props.editRiderItem(item) : null} />
                                )
                              })
                            : null
                          }
                        </div>
                      )
                    } else {
                      return null
                    }
                  })
                }
              </div>
            </div>

            {provided.placeholder}
          </div>
        )}
      </Draggable>
    )
  }
}

TableGroup.propTypes = {
  view: PropTypes.object,
  value: PropTypes.string,
  item: PropTypes.object,
  itemIndex: PropTypes.number,
  itemTypes: PropTypes.array,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  deleteRiderItemGroup: PropTypes.func,
  members: PropTypes.array,
  paging: PropTypes.object
}

TableGroup.defaultProps = {
  view: {},
  value: '',
  item: {},
  itemIndex: undefined,
  itemTypes: [],
  createRiderItem: function() {},
  editRiderItem: function() {},
  deleteRiderItem: function() {},
  deleteRiderItemGroup: function() {},
  members: [],
  paging: {}
}

export default TableGroup



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/output-table/table-group.js